import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import * as notificationsApi from "@/api/endpoints/notifications"
import type { GetNotificationsParams } from "@/api/endpoints/notifications"

export const notificationKeys = {
  all: ["notifications"] as const,
  inbox: (params?: GetNotificationsParams) =>
    [...notificationKeys.all, "inbox", params ?? {}] as const,
  unreadCount: () => [...notificationKeys.all, "unread-count"] as const,
}

export const useGetNotificationsQuery = (
  params?: GetNotificationsParams,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: notificationKeys.inbox(params),
    queryFn: () => notificationsApi.getNotifications(params),
    enabled: options?.enabled ?? true,
  })

export const useGetNotificationsUnreadCountQuery = (options?: {
  enabled?: boolean
}) =>
  useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () => notificationsApi.getNotifications({ page: 1, pageSize: 1 }),
    select: (response) => response.unreadCount ?? 0,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: true,
    placeholderData: (previousData) => previousData,
  })

export const useMarkNotificationReadMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: notificationsApi.markNotificationRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}

export const useMarkAllNotificationsReadMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: notificationsApi.markAllNotificationsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}
